<template>
  <v-layout align-center justify-center>
    <v-card class="elevation-12" align-center justify-center>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Vendor Management</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn  color="info" @click.stop="logOut">
          <v-icon>close</v-icon>
          Log Out
        </v-btn>
      </v-toolbar>
      <v-img
        :src="logo"
        height="150"
        contain
      ></v-img>

    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md7 order-xs2 order-md1>
                <v-flex xs6 md9></v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.name"
                        @keyup.enter="save"
                        label="Name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.abbrev"
                        @keyup.enter="save"
                        label="Abbrev"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.address"
                    @keyup.enter="save"
                    label="Address"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs10 md5>
                      <v-text-field
                        v-model="editedItem.city"
                        @keyup.enter="save"
                        label="City"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 md2>
                      <v-text-field
                        v-model="editedItem.state"
                        @keyup.enter="save"
                        label="ST"
                        mask="AA"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md5>
                      <v-text-field
                        v-model="editedItem.zip"
                        @keyup.enter="save"
                        label="Zipcode"
                        mask="#####"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
              <v-flex xs12 md5 order-xs1 order-md2 class="text-xs-center">
                <v-img v-if="editedItem.logo" class="mx-auto" max-width="250" :src="editedItem.picture" alt="Company Logo" />
                <v-img v-else class="mx-auto" max-width="250" src="/static/img/new.png" alt="Company Logo" />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 md3>
                <v-text-field
                  v-model="editedItem.phone"
                  @keyup.enter="save"
                  mask="(###) ###-####"
                  return-masked-value
                  label="Phone"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md5>
                <v-text-field
                  v-model="editedItem.country"
                  @keyup.enter="save"
                  label="Country"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-select
                  v-model="editedItem.VendorCategoryId"
                  :items="categories"
                  item-text="category"
                  item-value="id"
                  label="Category"
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItem.webSite"
                  @keyup.enter="save"
                  label="Website"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 class="text-xs-center text-md-right">
                <!-- <v-btn @click="getPhotos()" color="primary">Upload Photos</v-btn> -->
                <v-btn @click="addInsurance()" color="primary">Proof of Insurance</v-btn>
                <v-btn @click="addContact()" color="primary">Manage Contacts</v-btn>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editedItem.profile"
                  label="Company Profile"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 class="text-xs-center title">
                {{ currentYear }} Elizabeth Stampede
              </v-flex>
              <v-flex xs12 class="title red--text">
                We will be participating in {{ currentYear }}
                <v-radio-group v-model="editedItem.returning" row>
                  <v-radio label="Rodeo" value="Yes" color="red"></v-radio>
                  <v-radio label="Rodeo and Concert" value="Both" color="red"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  :headers="boothHeaders"
                  :items="editedItem.VendorBooths"
                  hide-actions
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.boothNumber }}</td>
                    <td class="text-xs-center">{{ props.item.size }}</td>
                    <td class="text-xs-center">{{ props.item.area }}</td>
                    <td class="text-xs-center">{{ props.item.location }}</td>
                    <td class="text-xs-center">{{ props.item.status }}</td>
                    <td class="justify-center layout px-0">
                      <v-icon
                        @click="updateBooth(props.item)"
                      >
                        map
                      </v-icon>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs6 lg3>
                <v-btn :href="terms" target="_blank" color="primary">Handbook and Terms PDF</v-btn>
              </v-flex>
              <v-flex xs6 lg3 class="text-md-center">
                <!-- <v-btn @click="sendStatement" color="primary">Email Statement</v-btn> -->
              </v-flex>
              <v-flex xs6 lg3 class="text-md-center">
                <v-btn @click="makePayment()" color="primary">Payment</v-btn>
              </v-flex>
              <v-flex xs6 lg3 class="text-xs-right">
                <v-btn color="primary" @click="save">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-form>
  </v-card>

  <v-dialog v-model="dialogPay" max-width="500px" persistent>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card >
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="closeThis()">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add Payment</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="savePayment">Submit</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout class="pb-3" row wrap>
                <v-flex xs6>
                  <strong>Amount Due {{ grandTotalDisplay }}</strong>
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu1"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedDate"
                      label="Date"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="evalItem.date"
                      no-title
                      @input="menu1 = false"
                      @change="formattedDate = formatDate(evalItem.date)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Credit Card'" xs12>
                  <v-text-field
                    v-model="evalItem.cardNumber"
                    label="Card #"
                    mask="credit-card"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Credit Card'" xs12>
                  <v-text-field
                    v-model="evalItem.cardName"
                    label="Card Name"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Credit Card'" xs4>
                  <v-text-field
                    v-model="evalItem.cardExpire"
                    label="Expire Date"
                    mask="##/##"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Credit Card'" xs5></v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Credit Card'" xs3>
                  <v-text-field
                    v-model="evalItem.cardCvv"
                    label="CVV"
                    mask="####"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Check'" xs12>
                  <v-text-field
                    v-model="evalItem.cardNumber"
                    label="Check #"
                  ></v-text-field>
                </v-flex>
                <v-flex xs8></v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Cash' || evalItem.paymentMode === 'Check' || evalItem.paymentMode === 'Credit Card'" xs4>
                  <v-text-field
                    v-model="evalItem.amount"
                    label="Amount"
                    prefix="$"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Cash' || evalItem.paymentMode === 'Check' || evalItem.paymentMode === 'Credit Card'" xs12>
                  <v-text-field
                    v-model="evalItem.notes"
                    label="Notes"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Cash' || evalItem.paymentMode === 'Check' || evalItem.paymentMode === 'Credit Card'" xs12 sm3>
                  <v-checkbox
                    v-model="evalItem.emailReceipt"
                    label="Email Receipt"
                  ></v-checkbox>

                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Cash' || evalItem.paymentMode === 'Check' || evalItem.paymentMode === 'Credit Card'" xs12 sm9>
                  <v-text-field
                    v-model="evalItem.email"
                    label="Email Address"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="dialogInsurance"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="closeThis()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Proof of Insurance</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="saveInsurance()">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-text-field
                  label="Select..."
                  @click='onPickFile'
                  v-model='fileName'
                  prepend-icon="attach_file"
                ></v-text-field>
                <!-- Hidden -->
                <input
                  type="file"
                  style="display: none"
                  ref="fileInput"
                  accept="*/*"
                  @change="onFilePicked">
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <ContactList
      :visible="dialogContact"
      :item="item"
      :key="item.id"
      @close="closeThis"
    />

    <PhotoList
      :visible="dialogPhoto"
      :item="item"
      :currentYear="currentYear"
      :key="item.id"
      @close="closeThis"
    />

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'
import ContactList from './ContactList.vue'
import PhotoList from './PhotoList.vue'

export default {
  props: ['visible', 'item', 'currentYear'],

  components: {
    ContactList,
    PhotoList
  },

  data () {
    return {
      terms: process.env.API_URL + '/vendor/Vendor_Handbook_and_TsCs.pdf',
      logo: this.$store.state.logo,
      valid: true,
      valid2: true,
      activeTab: '',
      newBoothId: 0,
      dialogPay: false,
      dialogInsurance: false,
      dialogContact: false,
      dialogPhoto: false,
      menu1: false,
      emailReceipt: false,
      fileName: {},
      files: [],
      formattedDate: '',
      grandTotalDisplay: 0,
      saving: false,
      yesNo: ['Yes', 'No'],
      required: [
        { name: 'Received', value: 'Yes' },
        { name: 'Required', value: 'No' }
      ],
      checkIns: [
        { name: 'Standard', value: 'No' },
        { name: 'Saturday', value: 'Yes' },
        { name: 'Sunday', value: 'Sunday' }
      ],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      boothHeaders: [
        {text: 'Booth #', align: 'center', sortable: false, value: 'boothNumber'},
        {text: 'Size', align: 'center', sortable: false, value: 'size'},
        {text: 'Area', align: 'center', sortable: false, value: 'area'},
        {text: 'Location', align: 'center', sortable: false, value: 'location'},
        {text: 'Status', align: 'center', sortable: false, value: 'Status'},
        {text: 'Map', align: 'center', sortable: false, value: 'id'}
      ],
      permitHeaders: [
        {text: 'Type', align: 'center', sortable: false, value: 'type'},
        {text: 'Number', align: 'center', sortable: false, value: 'permitNumber'},
        {text: 'Note', align: 'center', sortable: false, value: 'note'},
        {text: 'Edit', align: 'center', sortable: false, value: 'id'}
      ],
      editedItem: this.item,
      evalItem: {},
      categories: [],
      contacts: []
    }
  },

  created () {
    this.getCategories()
    this.getContacts()
    this.loadItem()
  },

  methods: {
    loadItem () {
      this.editedItem = this.item

      if (this.editedItem.VendorDetails.checkIn === 'Yes') {
        this.editedItem.VendorDetails.checkIn = 'Saturday'
      } else if (this.editedItem.VendorDetails.checkIn === 'No') {
        this.editedItem.VendorDetails.checkIn = 'Standard'
      }

      let booth = this.item.VendorBooths.sort((a, b) => {
        let fa = a.boothNumber
        let fb = b.boothNumber

        if (fa < fb) {
          return -1
        }
        if (fa > fb) {
          return 1
        }

        return 0
      })

      this.item.VendorBooths = booth
    },

    async getCategories () {
      try {
        const response = await Api().get('extern_vendor_categories/')
        this.categories = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async sendStatement () {
      try {
        let statement = {}

        statement.date = moment().format('MM/DD/YYYY')
        statement.item = this.item
        statement.rows = this.rows
        console.log(statement)

        const response = await Api().post('extern_vendor_statement', statement)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async save () {
      if (this.$refs.form.validate()) {
        try {
          const response = await Api().put('vendors/' + this.editedItem.id, this.editedItem)

          console.log(response.data)
          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    addContact () {
      this.dialogContact = true
    },

    addInsurance () {
      this.dialogInsurance = true
    },

    getPhotos () {
      this.dialogPhoto = true
    },

    onPickFile () {
      this.$refs.fileInput.click()
    },

    onFilePicked (event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        this.fileName = files[0].name
        // Check validity of file
        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }
        // If valid, continue
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.url = fr.result
          this.fileObject = files[0] // this is an file that can be sent to server...
        })
      } else {
        this.fileName = ''
        this.fileObject = null
        this.url = ''
      }
    },

    async saveInsurance () {
      let filenames = []

      let formData = new FormData()
      formData.append('name', 'Proof of Insurance')
      formData.append('year', this.currentYear)
      formData.append('fileName', this.fileName)
      formData.append('UserId', 289)
      formData.append('VendorCompanyId', this.item.id)

      for (var i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i])
        filenames.push(this.files[i].name)
      }

      formData.append('files', this.fileObject)

      try {
        const response = await Api().post('vendor_files1', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

        this.closeThis()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async makePayment () {
      console.log('test')
      try {
        const response = await Api().get('extern_vendor_accounting/' + this.item.id + '/' + this.currentYear)

        let rows = response.data

        let amount = 0
        let grandTotal = 0
        for (let i in rows) {
          if (rows[i].status === 'Void') {
            amount = 0
          } else {
            if (rows[i].VendorAccountingDetails.length > 0) {
              amount = 0
              for (let j in rows[i].VendorAccountingDetails) {
                console.log(rows[i].VendorAccountingDetails[j])
                amount = amount + rows[i].VendorAccountingDetails[j].quantity * rows[i].VendorAccountingDetails[j].price
              }
            } else {
              amount = Number(rows[i].amount) * -1
            }
          }

          grandTotal = grandTotal + amount
          // console.log(grandTotal)
        }

        this.grandTotal = grandTotal
        this.grandTotalDisplay = grandTotal.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        this.evalItem = {}
        this.evalItem.date = moment().format('YYYY-MM-DD')
        this.formattedDate = moment().format('MM/DD/YYYY')
        this.evalItem.name = this.item.name
        this.evalItem.address = this.item.address
        this.evalItem.city = this.item.city
        this.evalItem.state = this.item.state
        this.evalItem.zip = this.item.zip
        this.evalItem.amount = this.grandTotal
        this.evalItem.paymentType = null
        this.evalItem.paymentMode = 'Credit Card'
        this.evalItem.emailReceipt = false
        this.evalItem.email = this.item.VendorContacts[0].email
        this.dialogPay = true
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async savePayment () {
      try {
        this.evalItem.VendorCompanyId = this.item.id
        this.evalItem.type = 'Payment'
        this.evalItem.status = 'Open'
        this.evalItem.createdBy = this.myId
        this.evalItem.year = this.currentYear
        this.evalItem.payType = this.evalItem.paymentMode
        console.log(this.evalItem)

        const response = await Api().post('extern_vendor_payment', this.evalItem)
        let payment = response.data.payment
        console.log('Payment', payment)
        payment.formattedDate = this.formatDate(payment.date)
        payment.amount = Number(payment.amount)
        payment.amountDisplay = payment.amount.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        this.grandTotal = this.grandTotal - Number(payment.amount)
        console.log(this.grandTotal, this.grandTotal, Number(payment.amount))
        this.grandTotalDisplay = this.grandTotal.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        this.closeThis()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    closeThis (item) {
      this.evalItem = {}
      this.dialogPay = false
      this.dialogInsurance = false
      this.dialogContact = false
      this.dialogPhoto = false
    },

    async updateBooth (item) {
      // try {
      //   item.VendorCompanyId = null

      //   const response = await Api().put('vendor_booths/' + item.id, item)

      //   const arr = this.item.VendorBooths.filter(booth => booth.id !== item.id)

      //   this.item.VendorBooths = arr

      //   this.snackbar.message = response.data.message
      //   this.snackbar.color = 'success'
      //   this.snackbar.show = true
      // } catch (error) {
      //   this.snackbar.message = error.response.data.error
      //   this.snackbar.color = 'error'
      //   this.snackbar.show = true
      // }
    },

    async getContacts () {
      try {
        const response = await Api().get('extern_vendor_contacts/' + this.item.id)

        this.contacts = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    logOut () {
      // this.$session.destroy()
      this.$router.go(this.$router.currentRoute)
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/vendorExtern/InternalForm.vue